import arcane from './arcane'
import fire from './fire'
import frost from './frost'

const mage = { specs: [arcane, fire, frost] }

export default mage
